import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  submitOnChange() {
    this.element.requestSubmit()
  }

  setToday() {
    const today = new Date().toISOString().split('T')[0]
    this.inputTarget.value = today
    this.element.requestSubmit()
  }
}
